import { ILocalize } from 'features/common/types';
import { GatewayDocumentTypeEnum } from 'features/transactions/types';
import { OrderDataToClient } from 'features/payment/types';
import { PaymentContactData } from './fetchPaymentContactData';
import { splitCardholderName } from './splitCardholderName';

export const DLOCAL_DEFAULT_ADDRESS = 'Rufino Bauza 2460';
export const DLOCAL_DEFAULT_ZIP_CODE = '11300';
export const DLOCAL_DEFAULT_CITY_STATE = 'Montevideo';

export interface DLocalTitularDefaultValues {
	orderId: string;
	firstName: string;
	lastName: string;
	document: string;
	documentType: number;
	email: string;
	phone: string;
	address: string;
	zipCode: string;
	state: string;
	city: string;
}

export const resolveCedulaDocumentTypeId = (billingDocumentTypes: { id: number; name: string }[]): number => {
	const cedula = billingDocumentTypes.find((type) => {
		const normalized = type.name.toLowerCase();
		return (
			normalized.includes('cédula') ||
			normalized.includes('cedula') ||
			normalized === 'ci' ||
			normalized.includes('cédula de identidad')
		);
	});

	return cedula?.id ?? GatewayDocumentTypeEnum.CEDULA;
};

/** Valores iniciales del titular de pago en DLocal: tarjeta C2A + contacto del caso solo para email/teléfono. */
export const buildDLocalTitularDefaults = (
	orderData: OrderDataToClient,
	contact: PaymentContactData | null,
	cardholder: string,
	cardDocument: string,
	clientLocation?: ILocalize | null,
): DLocalTitularDefaultValues => {
	const isInternalCapture = Boolean(cardholder?.trim());
	const nameSource = isInternalCapture ? cardholder : contact?.name || '';
	const { firstName, lastName } = splitCardholderName(nameSource);
	const cityFromLocation = clientLocation?.city || '';

	return {
		orderId: orderData.orderId,
		firstName,
		lastName,
		document: cardDocument || '',
		documentType: resolveCedulaDocumentTypeId(orderData.billingDocumentTypeToShow),
		email: contact?.email || '',
		phone: contact?.phone || '',
		address: isInternalCapture ? DLOCAL_DEFAULT_ADDRESS : '',
		zipCode: isInternalCapture ? DLOCAL_DEFAULT_ZIP_CODE : '',
		state: isInternalCapture ? DLOCAL_DEFAULT_CITY_STATE : cityFromLocation,
		city: isInternalCapture ? DLOCAL_DEFAULT_CITY_STATE : cityFromLocation,
	};
};
